module.exports = __webpack_public_path__ + "static/image3-ab09d83e39c8f01125a33ebe09840c70.jpg";